import { UserLocation } from "@nova/schemas"
import { createExternalStore } from "@nova/toolkit-pure-hooks"

const MAX_PATH_POINTS = 1000

const store = createExternalStore<UserLocation>()
const pathStore = createExternalStore<UserLocation[]>()

export const userLocationStore = {
    push: (location: UserLocation) => {
        store.set(location.userId, location)
        const existingPath = pathStore.getItem(location.userId) ?? []
        pathStore.set(location.userId, [...existingPath, location].slice(-MAX_PATH_POINTS))
    },
    remove: (userId: string) => {
        store.remove(userId)
        pathStore.remove(userId)
    },
    flush: () => {
        store.flush()
        pathStore.flush()
    },
    get: store.get,
    useAll: store.useAll,
    useAllPaths: pathStore.useAll,
}

export const useUserLocation = store.useItem
